import React, { useEffect, useState } from 'react';
import { useSite } from '../useSite';

export const WHATSAPP_CONTACTS = [
  { name: 'Leonardo Rifa', phone: '17867279086' },
  { name: 'Daniel Lariot', phone: '17542727823' },
];
const REFERENCE_DAY = Date.UTC(2026, 9, 21);

export const newYorkDay = (now = new Date()) => {
  const [y, m, d] = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' })
    .format(now).split('-').map(Number);
  return Date.UTC(y, m - 1, d);
};

export const contactForDate = (now = new Date()) => {
  const days = Math.round((newYorkDay(now) - REFERENCE_DAY) / 86400000);
  return WHATSAPP_CONTACTS[((days % 2) + 2) % 2];
};

export const whatsappUrl = (contact, message) => `https://wa.me/${contact.phone}?text=${encodeURIComponent(message)}`;

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="h-6 w-6" fill="currentColor">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.48.71.31 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.43 9.43 0 0 1-1.45-5.03c0-5.2 4.24-9.44 9.45-9.44a9.38 9.38 0 0 1 6.68 2.77 9.38 9.38 0 0 1 2.76 6.68c0 5.2-4.24 9.44-9.45 9.44zm8.04-17.48A11.3 11.3 0 0 0 12.05.7C5.78.7.68 5.8.68 12.06c0 2 .52 3.96 1.52 5.68L.58 23.3l5.7-1.5a11.34 11.34 0 0 0 5.77 1.47h.01c6.26 0 11.36-5.1 11.36-11.36 0-3.03-1.18-5.89-3.33-8.03z" />
  </svg>
);

export const WhatsAppButton = () => {
  const { t } = useSite();
  const [contact, setContact] = useState(null);
  const [typing, setTyping] = useState(false);
  useEffect(() => {
    setContact(contactForDate());
    const isField = (e) => e.target.matches?.('input, textarea, select');
    const onIn = (e) => isField(e) && setTyping(true);
    const onOut = (e) => isField(e) && setTyping(false);
    document.addEventListener('focusin', onIn);
    document.addEventListener('focusout', onOut);
    return () => {
      document.removeEventListener('focusin', onIn);
      document.removeEventListener('focusout', onOut);
    };
  }, []);
  if (!contact || typing) return null;
  const label = t.whatsapp.label(contact.name);
  return (
    <a
      href={whatsappUrl(contact, t.whatsapp.message)} target="_blank" rel="noopener noreferrer"
      aria-label={label} title={label} data-testid="whatsapp-float-btn" data-contact={contact.phone}
      className="fixed bottom-4 right-4 z-40 flex h-12 w-12 items-center justify-center rounded-full border border-tan/60 bg-kombu-green text-bone-light shadow-[0_10px_30px_-12px_rgba(53,64,36,0.6)] transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-kombu-green-dark md:bottom-7 md:right-7"
    >
      <WhatsAppIcon />
    </a>
  );
};
